var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 37,
    viewBox: "0 0 30 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2753 0.5H9.89437C9.43425 0.5 8.99296 0.682743 8.66755 1.00829L1.49755 8.17802C1.17214 8.50342 0.989258 8.94471 0.989258 9.40483V34.765C0.989258 35.7232 1.76614 36.5001 2.72437 36.5001H27.2752C28.2334 36.5001 29.0103 35.7232 29.0103 34.765V2.23511C29.0104 1.27689 28.2336 0.5 27.2753 0.5ZM9.38861 5.19457V8.89914H5.68397L9.38861 5.19457ZM25.5402 33.0299H4.45955V12.3694H11.1237C12.0819 12.3694 12.8588 11.5925 12.8588 10.6343V3.97022H25.5402V33.0299Z",
    fill: "#1A5785"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8125 16.6698C8.8125 17.628 9.58939 18.4049 10.5476 18.4049H20.4368C21.395 18.4049 22.1719 17.628 22.1719 16.6698C22.1719 15.7116 21.395 14.9347 20.4368 14.9347H10.5475C9.58932 14.9348 8.8125 15.7116 8.8125 16.6698Z",
    fill: "#1A5785"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4363 20.6482H10.5471C9.5889 20.6482 8.81201 21.4251 8.81201 22.3833C8.81201 23.3415 9.5889 24.1184 10.5471 24.1184H20.4363C21.3946 24.1184 22.1714 23.3415 22.1714 22.3833C22.1714 21.4251 21.3946 20.6482 20.4363 20.6482Z",
    fill: "#1A5785"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4363 26.3619H10.5471C9.5889 26.3619 8.81201 27.1388 8.81201 28.097C8.81201 29.0553 9.5889 29.8322 10.5471 29.8322H20.4363C21.3946 29.8322 22.1714 29.0553 22.1714 28.097C22.1714 27.1388 21.3946 26.3619 20.4363 26.3619Z",
    fill: "#1A5785"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport5);
export default __webpack_public_path__ + "static/media/report5.f280b49d948e0b96b43f3faa11af8578.svg";
export { ForwardRef as ReactComponent };